module.exports = __webpack_public_path__ + "static/media/telkom2.551ca944.jpg";